import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { AlertWarningCircleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorIconDestructive, colorTextDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { MeetingsDropdown } from './meetings_dropdown';
import { filterBusyTimesByQuery } from './utils';
const containerCss = "c1rjdgkz";
const Container = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const meetingsCountButtonCss = "m6u4t71";
const MeetingsCountButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(meetingsCountButtonCss, props.className)} />);
const createMeetingsCountButton = toggle => props => <MeetingsCountButton onClick={toggle} {...props} />;
export const SearchResults = ({
  type,
  searchTerm,
  suggestions,
  isSearching,
  hasSearchError
}) => {
  const [toggle, Dropdown] = useDropdown();
  const meetingsCountButton = useMemo(() => createMeetingsCountButton(toggle), [toggle]);
  if (!searchTerm) {
    return null;
  }
  if (isSearching) {
    return <BodyText size="medium">
        <em>
          {I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.searching_calendars_status')}
        </em>
      </BodyText>;
  }
  if (hasSearchError) {
    return <BodyText color={colorTextDestructive} size="medium">
        <AlertWarningCircleIcon color={colorIconDestructive} spacingRight="4" />
        {I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.search_error')}
      </BodyText>;
  }
  const filteredSuggestions = filterBusyTimesByQuery(suggestions, searchTerm, type);
  if (!filteredSuggestions.length) {
    return <BodyText size="medium">
        {I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.no_results_status')}
      </BodyText>;
  }
  return <Container>
      <BodyText size="medium">
        {HtmlParser(I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.results_found_status', {
        count: filteredSuggestions.length
      }), {
        MeetingsCountButton: meetingsCountButton
      })}
      </BodyText>
      <Dropdown>
        <MeetingsDropdown meetings={filteredSuggestions} searchTerm={searchTerm} />
      </Dropdown>
    </Container>;
};

require("./search_results.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_results.js");